<template>
  <q-page padding>
    <PageHeader
      title="Gestão de Menus"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="q-pt-md">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        title="Menus e Mapeamentos"
        :rows="rows"
        :columns="columns"
        dense
        class="tabela-tamanho-fixo"
        :loading="disable"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template #body-cell-submenus="props">
          <q-td>
            <div
              class="row"
              v-for="(sub, index) in props.row.submenus"
              :key="index"
            >
              <span>{{ sub.description }}</span>
              <q-icon class="cursor" name="delete" size="sm" color="red" />
            </div>
            <div class="row col-1">
              <q-input dense outlined v-model="props.row.teste" label="Nome">
              </q-input>
              <q-btn
                @click="adicionarMenu(props.row.id, props.row.teste)"
                flat
                color="positive"
                dense
                round
                icon="add"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-roles="props">
          <q-td>
            <div
              class="row"
              v-for="(role, index) in props.row.roles"
              :key="index"
            >
              <span>{{ role.name }}</span>
              <q-icon class="cursor" name="delete" size="sm" color="red" />
            </div>
            <div class="row col-1">
              <q-input dense outlined v-model="props.row.teste" label="Nome">
              </q-input>
              <q-btn
                @click="adicionarRole(props.row.id, props.row.role)"
                flat
                color="positive"
                dense
                round
                icon="add"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </div>

    <q-card class="q-mt-md">
      <q-tabs
        v-model="tab"
        dense
        class="text-grey"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab name="menus" label="Menus" />
        <q-tab name="sub" label="Sub Menus" />
        <q-tab name="roles" label="Roles" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="menus">
          <div class="text-h6">Menus</div>
          <menus />
        </q-tab-panel>

        <q-tab-panel name="sub">
          <div class="text-h6">Sub Menus</div>
          <sub-menus />
        </q-tab-panel>

        <q-tab-panel name="roles">
          <div class="text-h6">Roles</div>
          <roles />
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "description",
    label: "Menu",
    field: "description",
    align: "left",
  },
  {
    name: "submenus",
    label: "SubMenus",
    field: "submenus",
    align: "left",
  },
  {
    name: "roles",
    label: "Perfis",
    field: "roles",
    align: "left",
  },
];

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import Menus from "../components/Menus.vue";
import SubMenus from "../components/SubMenus.vue";
import Roles from "../components/Roles.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { Menus, SubMenus, Roles, PageHeader },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const $q = useQuasar();
    const disable = ref(true);
    const selected = ref(0);
    const value = ref([]);
    const subMenu = ref("");
    const filter = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 15,
    });

    const getMenu = async (page = 0, rowsPerPage = 8) => {
      const response = await store.dispatch("adminMultpex/getMenu", {
        page,
        per_page: rowsPerPage,
        search: filter.value,
      });
      rows.value = response.data.results.data;
      disable.value = false;
    };

    onMounted(getMenu);

    const handleRequest = async () => {
      getMenu(pagination.value.page, pagination.value.rowsPerPage);
    };

    const adicionarMenu = async (menu_id, teste) => {
      try {
        await store.dispatch("adminMultpex/setMenus", {
          menu_id,
          submenus: [{ id: teste }],
        });

        $q.notify({
          message: "Menu adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o adicionar menu",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarRole = async (menu_id, role) => {
      try {
        await store.dispatch("adminMultpex/setRole", {
          menu_id,
          roles: [{ id: role }],
        });

        $q.notify({
          message: "Menu adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o adicionar menu",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      subMenu,
      value,
      handleRequest,
      filter,
      adicionarMenu,
      adicionarRole,
      tab: ref("menus"),
    };
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
</style>
